import { PageContainer } from "src/components/organisms/contents";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { showAlert } from "src/components/containers/Alert";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";

export const PointBoxDetails = () => {
  const navi = useNavigate();
  const { state } = useLocation();

  const { data: userInfo } = useUserRegister();
  return (
    <PageContainer isNavBar={false} active={null} $bgColor={"#fff"}>
      <>
        {/* 헤더 */}
        <SubConHeader
          title="포인트박스"
          $bgColor="#fff"
          onClickArrow={() => navi(-1)}
        />

        {/* 상품 정보 */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            padding: "16px 0 90px",
            gap: 16,
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "100%",
                height: "328px",
                borderRadius: 16,
                overflow: "hidden",
                objectFit: "cover",
              }}
            >
              <img
                src={state.imgSrc}
                alt={state.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: 12,
                marginBottom: 12,
                paddingBottom: 16,
              }}
            >
              <span
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#A3A3A3",
                }}
              >
                {state.title}
              </span>
              <span
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  lineHeight: "24px",
                  color: "#404040",
                }}
              >
                {state.name}
              </span>
              <span
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  lineHeight: "24px",
                  color: "#F57C00",
                }}
              >
                {state.price.toLocaleString()}P
              </span>
            </div>
            {/* 상품 상세정보 */}
            <div style={{ width: "100%", padding: "16px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 16,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#737373",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    lineHeight: "24px",
                    color: "#404040",
                  }}
                >
                  상품 상세정보
                </span>
                <span>
                  [상품명] <br />
                  {state.title} {state.name}
                </span>
                <span>
                  [상품소개] <br />
                  깊고 깔끔한 풍미의 에스프레소를 즐길 수 있는 스타벅스
                  아메리카노 Tall 사이즈 음료입니다.
                </span>
                <span>
                  전국 스타벅스 매장에서 사용 가능한 모바일 쿠폰 상품이며,
                  건강한 루틴 실천에 대한 작지만 기분 좋은 보상으로 제공됩니다.
                </span>
              </div>
            </div>
            {/* 교환 및 이용 안내 */}
            <div style={{ width: "100%", padding: "16px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 16,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#737373",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    lineHeight: "24px",
                    color: "#404040",
                  }}
                >
                  교환 및 이용 안내
                </span>
                <ul>
                  <li
                    style={{
                      fontWeight: 700,
                      color: "#404040",
                      marginBottom: 8,
                    }}
                  >
                    이용 안내
                  </li>
                  <li>
                    - 본 상품은 루틴케어 포인트로만 교환 가능하며, 교환 후 취소
                    및 환불은 불가합니다
                  </li>
                  <li>
                    - 교환이 완료되면, 등록된 휴대폰 번호로 문자(SMS)를 통해
                    모바일 상품권이 발송됩니다
                  </li>
                  <li>
                    - 문자로 받은 쿠폰 이미지를 클릭해 바코드를 확인하고, 매장
                    직원에게 제시하면 교환이 가능합니다
                  </li>
                  <li>
                    - 쿠폰 사용 시 메뉴 변경 및 사이즈 업그레이드는 매장 정책에
                    따라 불가할 수 있습니다.
                  </li>
                </ul>
                <ul>
                  <li
                    style={{
                      fontWeight: 700,
                      color: "#404040",
                      marginBottom: 8,
                    }}
                  >
                    유효기간 및 환불정책
                  </li>
                  <li>- 쿠폰은 발급일로부터 60일간 유효합니다</li>
                  <li>
                    - 유효기간 경과 시 자동 소멸되며, 유효기간 연장 및 포인트
                    복원은 불가합니다
                  </li>
                  <li>
                    - 사용하지 못한 경우에도 별도 보상이나 환불이 제공되지
                    않으니, 기간 내 사용을 권장드립니다
                  </li>
                </ul>
              </div>
            </div>

            {/* 결제, 사용 조건 */}
            <div style={{ width: "100%", padding: "16px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 16,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#737373",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    lineHeight: "24px",
                    color: "#404040",
                  }}
                >
                  결제·사용 조건
                </span>
                <ul>
                  <li
                    style={{
                      fontWeight: 700,
                      color: "#404040",
                      marginBottom: 8,
                    }}
                  >
                    영수증 및 결제 안내
                  </li>
                  <li>
                    - 본 상품은 루틴케어 리워드 포인트로 교환된 모바일
                    쿠폰이므로, 현금영수증 및 세금계산서 발급 대상이 아닙니다.
                  </li>
                  <li>
                    - 음료 수령 시 일부 매장에서 간이 영수증 제공은 가능하며,
                    정확한 발급 여부는 매장 정책에 따릅니다.
                  </li>
                </ul>
                <ul>
                  <li
                    style={{
                      fontWeight: 700,
                      color: "#404040",
                      marginBottom: 8,
                    }}
                  >
                    사용 가능 매장 안내
                  </li>
                  <li>
                    - 본 쿠폰은 전국 스타벅스 매장에서 사용 가능하며, 단, 일부
                    매장(인천공항점, 병원점, 고속도로휴게소 등)에서는 사용이
                    제한될 수 있습니다.
                  </li>
                  <li>
                    - 자세한 사용 가능 매장은{" "}
                    <a
                      href="https://www.starbucks.co.kr"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#404040", textDecoration: "underLine" }}
                    >
                      스타벅스 공식 홈페이지
                    </a>
                    에서 확인해주세요.
                  </li>
                </ul>
              </div>
            </div>

            {/* 사용자 주의사항 */}
            <div style={{ width: "100%", padding: "16px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 16,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#737373",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    lineHeight: "24px",
                    color: "#404040",
                  }}
                >
                  결제·사용 조건
                </span>
                <ul>
                  <li>
                    - 상품권을 받지 못했거나, 링크가 만료된 경우 [고객지원 &gt;
                    상품권 문의] 또는 문자 수신번호와 함께 문의 등록
                    부탁드립니다.
                  </li>
                  <li>
                    - 문제 확인 후, 쿠폰 재발송 또는 동일 포인트 복원 처리가
                    가능합니다.
                  </li>
                  <li>- 동일 상품은 1일 1회까지만 교환 가능합니다</li>
                  <li>- 타인에게 양도, 선물하기, 중고 판매는 불가합니다</li>
                  <li>
                    - 부정한 방법으로 획득한 포인트 사용 시 이용이 제한될 수
                    있습니다.
                  </li>
                </ul>
              </div>
            </div>

            {/* 자주 묻는 질문 (FAQ) */}
            <div style={{ width: "100%", padding: "16px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 16,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#737373",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    lineHeight: "24px",
                    color: "#404040",
                  }}
                >
                  자주 묻는 질문 (FAQ)
                </span>
                <ul>
                  <li style={{ display: "flex", gap: 6 }}>
                    <span
                      style={{
                        fontSize: 13,
                      }}
                    >
                      Q.
                    </span>
                    <div style={{ color: "#404040", fontWeight: 500 }}>
                      유효기간이 지나면 어떻게 되나요?
                    </div>
                  </li>
                  <div
                    style={{
                      margin: "8px 0",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
                    }}
                  />
                  <li style={{ display: "flex", gap: 6 }}>
                    <span
                      style={{
                        color: "#F57C00",
                        fontSize: 13,
                      }}
                    >
                      A.
                    </span>
                    <div>
                      교환이 완료되면 등록된 휴대폰 번호로 문자(SMS)가
                      발송됩니다.메시지 내 쿠폰 링크를 클릭하면 바코드를 확인할
                      수 있으며, 매장에서 바로 사용할 수 있습니다.
                    </div>
                  </li>
                </ul>
                <ul>
                  <li style={{ display: "flex", gap: 6 }}>
                    <span
                      style={{
                        fontSize: 13,
                      }}
                    >
                      Q.
                    </span>
                    <div style={{ color: "#404040", fontWeight: 500 }}>
                      문자를 못 받았어요. 어떻게 하나요?
                    </div>
                  </li>
                  <div
                    style={{
                      margin: "8px 0",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
                    }}
                  />
                  <li style={{ display: "flex", gap: 6 }}>
                    <span
                      style={{
                        color: "#F57C00",
                        fontSize: 13,
                      }}
                    >
                      A.
                    </span>
                    <div>
                      고객센터 또는 [상품권 문의하기] 기능을 통해휴대폰 번호와
                      함께 문의 접수해 주세요.확인 후, 재발송 또는 동일 포인트
                      복원 처리가 가능합니다.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {/* 하단 버튼 */}
            <div
              style={{
                width: "100%",
                maxWidth: "45rem",
                padding: 16,
                bottom: 0,
                position: "fixed",
                background: "white",
                borderTop: "1px rgba(0, 0, 0, 0.05) solid",
                display: "flex",
                flexDirection: "column",
                gap: 10,
                boxSizing: "border-box",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <button
                style={{
                  alignSelf: "stretch",
                  height: 48,
                  background: "#F57C00",
                  borderRadius: 8,
                  border: "none",
                  cursor: "pointer",
                  fontSize: 16,
                  color: "white",
                }}
                onClick={() => {
                  if (state.price > (userInfo?.point || 0)) {
                    showAlert("보유 포인트가 부족합니다");
                    return;
                  }
                  navi("/point/change", { state: state });
                }}
              >
                교환하기
              </button>
            </div>
          </div>
        </div>
      </>
    </PageContainer>
  );
};
